import menu from "./menu";

export default `${menu}`;
